import client from "./client";

export const saveAgree = (data) =>
    client.post('/api/save/survey', data);
